module.exports = __webpack_public_path__ + "img/chat-cross.6deb374.svg";